// mockFluentFfmpeg.js

const mockFfmpeg = require('./mockFfmpeg');

module.exports = mockFfmpeg;